module.exports = __webpack_public_path__ + "static/media/personal_settings.df1acbd5.svg";